<template>
  <div>
    <div class="center mgb10">
      <el-input
        size="small"
        v-model.trim="scanProcessedObj.serialNo"
        :placeholder="$t('text.serialNo')"
        autofocus
        clearable
        style="width: 300px"
        @keypress.enter.native="serialNoEnterKeyUp"
      />
    </div>
    <vxe-table
      :data="orders"
      class="recordsTable"
      size="mini"
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="images" :title="$t('product.images')" width="85">
        <template v-slot="{ row }">
          <thumbnail :images="row.images"></thumbnail>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="serialNo"
        :title="$t('text.serialNo')"
        min-width="80"
      >
        <template v-slot="{ row }">
          <small v-if="row.hurry" class="red"
            >({{ $t("order.hurrySimple") }})</small
          >
          {{ row.serialNo }}
          <div>
            <state-label :state="row.workflowState">{{
              $t("orderStates." + row.workflowState)
            }}</state-label>
          </div>
          <div class="font10">
            {{ $t("menu.customers") }}:{{ row.customerName }}
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="productNo"
        :title="$t('product.productNo')"
        min-width="80"
      >
        <template v-slot="{ row }">
          {{ row.productNo }}
          <div class="font10">
            {{ row.categoryName }}
            <span v-if="row.productBrand != null">/</span>
            {{ row.productBrand }}
          </div>
          <div>{{ row.color }} {{ row.size }}</div>
        </template>
      </vxe-table-column>

      <vxe-table-column
        field="quantity"
        :title="$t('text.quantity')"
        min-width="60"
      >
        <template v-slot="{ row }">
          {{ row.quantity }}{{ row.unit }}
          <div class="font10">
            {{ $t("order.complete") }}:{{ row.dealQuantity }}{{ row.unit }}
          </div>
          <el-popover
            placement="right"
            width="600"
            trigger="click"
            @show="getDeliveries(row)"
          >
            <vxe-table
              :data="deliveries"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  <span
                    v-if="
                      row.deliveryItems &&
                      row.deliveryItems != null &&
                      row.deliveryItems.length != 0
                    "
                  >
                    {{ row.deliveryItems[0].quantity }}
                  </span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="deliverBy"
                :title="$t('delivery.deliverBy')"
                min-width="60"
              />
              <vxe-table-column
                field="deliverAt"
                :title="$t('delivery.deliverAt')"
                min-width="60"
              />
              <vxe-table-column
                field="deliverType"
                :title="$t('delivery.deliveryMethode')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  <span v-if="row.deliverType != null">{{
                    $t("deliverTypes." + row.deliverType)
                  }}</span>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="express"
                :title="$t('delivery.express')"
                min-width="60"
              />
              <vxe-table-column
                field="deliverMethodName"
                :title="$t('delivery.channel')"
                min-width="60"
              />
              <vxe-table-column
                field="tracking"
                :title="$t('delivery.tracking')"
                min-width="60"
              />
              <vxe-table-column
                field="attachment"
                :title="$t('product.attachment')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  <zoom-imgs-text :srcs="row.attachment" :text="'附件'" />
                </template>
              </vxe-table-column>
            </vxe-table>
            <span slot="reference" class="popover-reference">
              <div class="font10 color-orange">
                {{ $t("order.deliveredQuantity") }}: {{ row.deliveredQuantity
                }}{{ row.unit }}
              </div>
            </span>
          </el-popover>
        </template>
      </vxe-table-column>
      <vxe-table-column :title="'扫描数量'" mini-width="120">
        <template v-slot="{ row }">
          <el-input
            v-model="row.scanQuantity"
            size="mini"
            :placeholder="row.unit"
          />
          <div
            v-if="row.scanQuantity > row.quantity - row.dealQuantity"
            class="red font10"
          >
            数量大于最大完成数量
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column :title="$t('text.remark')" mini-width="80">
        <template v-slot="{ row }">
          <raw-html-limit-number
            :content="row.remark"
            :number="8"
            type="richText"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column field="action" :title="$t('text.action')" width="50">
        <template v-slot="{ row, rowIndex }">
          <el-button type="text" @click="remove(row, rowIndex)" size="mini">
            {{ $t("text.remove") }}
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="right pd20">
      <span class="mgr10"> {{ $t("text.total") }}：{{ orders.length }} </span>
      <el-button
        size="small"
        type="primary"
        :loading="submitDoing"
        @click="submit('submit')"
      >
        {{ $t("text.submit") }}
      </el-button>

      <el-button
        size="small"
        type="success"
        :loading="submitDoing"
        @click="submit('submitAndDelivery')"
      >
        {{ $t("text.submit") }}并{{ $t("action.deliver") }}
      </el-button>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Util from "@/utils";
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import ThumbnailText from "@/components/ThumbnailText";
import Shop from "@/api/shop.js";
import Order from "@/api/order.js";
import Delivery from "@/api/delivery.js";

export default {
  mixins: [page],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      // 扫描生产结束
      scanProcessedObj: {
        serialNo: null,
      },
      orders: [],
      deliveries: [],
      submitDoing: false,
    };
  },
  created() {
    const self = this;
    self.orders = [];
    self.deliveries = [];
    self.scanProcessedObj.serialNo = null;
  },

  methods: {
    serialNoEnterKeyUp() {
      const self = this;
      if (self.orders.length > 100) {
        self.$message({
          message: "扫描大于100条数据，请先提交后再扫描",
          type: "warning",
        });
        return;
      }
      if (!self.scanProcessedObj.serialNo) {
        self.$message({
          message: "请扫描单号",
          type: "warning",
        });
        return;
      }
      Order.findBySerialNo({
        serialNo: Util.qrcodeAnalysis(
          self.scanProcessedObj.serialNo,
          "serialNo"
        ),
      }).then(function (res) {
        if (res.data.code == 200) {
          let order = res.data.entity;
          // 存在
          let existIndex = self.orders.findIndex(
            (o) => o.serialNo == order.serialNo
          );
          if (existIndex !== -1) {
            self.$message({
              message: self.$t("prompt.serialNoHasExist"),
              type: "warning",
            });
            return;
          }
          // 数量
          let maxScanQuantity = 0;
          if (self.Permit.isFreeEdition()) {
            maxScanQuantity = order.quantity - order.dealQuantity;
          } else {
            maxScanQuantity = order.quantity - order.receiveQuantity;
          }
          Vue.set(order, "_maxScanQuantity", maxScanQuantity);
          Vue.set(order, "scanQuantity", maxScanQuantity);
          //==
          if (maxScanQuantity <= 0) {
            self.$message({
              message: self.$t("prompt.serialNoProcessfinish"),
              type: "warning",
            });
            return;
          }
          self.orders.push(order);
        } else {
          self.$message({
            message: self.$t("prompt.notExixtSerialNo"),
            type: "warning",
          });
          return;
        }
      });
      self.scanProcessedObj.serialNo = null;
    },
    getDeliveries(row) {
      const self = this;
      self.deliveries = [];
      Delivery.findByOrderUuid(row.uuid).then(function (res) {
        self.deliveries = res.data;
      });
    },

    remove(row, rowIndex) {
      this.orders.splice(rowIndex, 1);
    },

    submit(type) {
      const self = this;
      if (self.orders.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      for (const o of self.orders) {
        if (
          !Util.regexQuantity(o.scanQuantity) ||
          o.scanQuantity > o.quantity ||
          o.scanQuantity > o._maxScanQuantity
        ) {
          self.$message({
            message: self.$t("rules.regex", [self.$t("text.quantity")]),
            type: "warning",
          });
          return;
        }
      }
      const data = self.orders.map((o) => {
        return {
          orderId: o.id,
          quantity: o.scanQuantity,
        };
      });
      self.submitDoing = true;
      Order.batchScanProcessed({
        isDirectDelivery: type == "submit" ? false : true,
        items: data,
      }).then(function (res) {
        if (res.status == 200) {
          self.submitDoing = false;
          self.sysResults(res.data, self.$t("prompt.dealSuccess"));
          self.$emit("updateData");
          self.$eventHub.$emit("orderBatchScanProcessed");
        } else {
          self.sysError();
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
